
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.012 5.012a2 2 0 012-2.012h9.09a2 2 0 011.495.671l2.898 3.26A2 2 0 0120 8.262V19a2 2 0 01-2 2H6.093a2 2 0 01-2-1.988l-.081-14z"}})])
          )
        }
      }
    